import React from 'react';
import clsx from 'clsx';
import IconTick from 'shared/ui/Icon/24/IconTick';
import { TagsLineV2 } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './Tag.module.scss';

type TagProps = {
  text?: string;
};

const Tag = ({ text, theme }: TagProps & Pick<TagsLineV2, 'bgColor' | 'theme'>) => (
  <div className={styles.tag}>
    <IconTick className={clsx(styles.icon, getThemeCSSClass(theme))} />
    <span className={clsx(styles.text, getThemeCSSClass(theme))}>{text}</span>
  </div>
);

export default Tag;
